const convert = require('heic-convert/browser');

export class HeicToJpegImageConverter {
    public static async convertHeicToJpeg(file: File): Promise<File> {
        const buffer = await file.arrayBuffer();
        const jpegBuffer = await convert({
            buffer: Buffer.from(buffer),
            format: 'JPEG',
            quality: 1
        });

        // Create a new file with the converted data
        const newFile = new File([jpegBuffer], file.name.replace(/\.heic$/i, '.jpg'), {
            type: 'image/jpeg'
        });
        return newFile;
    }
}